import { Body1 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import styled from 'styled-components'

export const FilterFormGrid = styled.div<{ readonly gridAmount: number }>`
    display: grid;
    grid-template-columns: repeat(${(props) => props.gridAmount}, 1fr);
    place-content: end;
    align-items: end;
    grid-gap: 15px;
`

export const Warning = styled(Body1)<{ readonly noMargin?: boolean; whiteText?: boolean }>`
    color: ${({ whiteText }) => (whiteText ? theme.colors.white : theme.colors.black)};
    background-color: rgba(255, 195, 39, 0.2);
    border: 0.1rem solid rgb(255, 195, 39);
    border-left: 10px solid rgb(255, 195, 39);
    padding: 10px;
    display: grid;
    place-items: center start;
    border-radius: ${theme.borderRadius.normal};
    margin: ${(props) => (props.noMargin ? '0' : '18px')} 0;
`

interface BorderProps {
    fullWidth?: boolean
    showAlways?: boolean
    color?: string
}
export const BlueBorder = styled.div<BorderProps>`
    width: ${({ fullWidth }) => (fullWidth ? '100%' : '70px')};
    height: 0px;
    border: 2px solid ${({ color }) => color ?? theme.colors.knowunityBlue};
    border-radius: 3px;
    margin-top: -25px;
    @media (max-width: 750px) {
        display: ${({ showAlways }) => (showAlways ? 'block' : 'none')};
    }
`

export const SectionWide = styled.section`
    width: 95%;
    max-width: 1600px;
    margin: 0 auto;
    padding: 30px 0;
`
